import { forwardRef, useEffect, useMemo, useRef } from 'react';
import gsap from 'gsap/all';
import { Text } from '@weareconceptstudio/core';

//* Style
import FaqItemStyle from './style';

//* Components
import Editor from '@/components/Editor';
import TitleAnim from '@/modules/_animation/Title';

const FaqItem = forwardRef(({ data, isFirst }, ref) => {
	//! Ref
	const contentRef = useRef();

	const itemData = useMemo(() => {
		return (
			<div
				ref={contentRef}
				className='wrapper-all-title-wrapper'
			>
				{data.faqs.map((el, i) => {
					const index = `${data.name}-${i}`;
					return (
						<div key={index}>
							<Text className='h6 font-larken-medium ask-text'>{el.question}</Text>
							<div className='answer-wrapper'>
								<Editor data={el.answer} />
							</div>
							<div className='line' />
						</div>
					);
				})}
			</div>
		);
	}, [data.faqs]);

	useEffect(() => {
		if (contentRef.current?.children?.length) {
			gsap.fromTo(contentRef.current.children, { opacity: 0 }, { opacity: 1, ease: 'power2.in', duration: 0.4, stagger: 0.1, delay: 0.9 });
		}
	}, [data.faqs]);

	return (
		<FaqItemStyle ref={ref}>
			{isFirst ? (
				<TitleAnim
					load={true}
					delayAnim={200}
					trigger={'bottom'}
				>
					<Text className='h3 font-larken-light wrapper-categories-title first-letter'>{data.name}</Text>
				</TitleAnim>
			) : (
				<Text className='h3 font-larken-light wrapper-categories-title first-letter'>{data.name}</Text>
			)}
			{itemData}
		</FaqItemStyle>
	);
});

export default FaqItem;
